import { Breadcrumb } from "@gull";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import {
  bookingDetails,
  exportBookedFlightByDist,
  getBookingHistoryByDist,
  offlineTicketHandler,
  refundInvoiceHandler,
  sendTicketInEmail,
  ticketHandler,
} from "app/services/AdminServices/bookingService";
import { refundAmount, totalAmountService } from "app/services/memberService";
import queryString from "app/services/queryStringService";
import config from "config.json";
import moment from "moment";
import Tooltip from "rc-tooltip";
import {
  Badge,
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Image,
  Row,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import {
  FaArrowsAltH,
  FaFileInvoice,
  FaLongArrowAltRight,
  FaUserCheck,
} from "react-icons/fa";
import {
  MdOutlineAirplaneTicket,
  MdOutlineRefresh,
  MdSearch,
  MdSystemUpdateAlt,
  MdTransferWithinAStation,
} from "react-icons/md";
import Swal from "sweetalert2";
import PassengerModal from "./Components/Booking/PassengerModal"; //./PassengerModal.jsx";
import TicketModal from "./Components/Booking/TicketModal";

import { AiFillFileExcel } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Insurance from "./Components/Booking/Insurance";
import MemberAutoComplete from "./Components/MemberAutoComplete";
import PnrAlert from "./PNR/PnrAlert";

function BookingHistory() {
  const { dateTimeFormat } = config;

  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canView, canEdit, canDelete });
  const navigate = useNavigate();
  const [showPassenger, setShowPassenger] = useState(false);
  const [showJourney, setShowJourney] = useState(false);

  const [showTicketModal, setShowTicketModal] = useState(false);
  const [ticketData, setTicketData] = useState({});
  const [passengers, setPassengers] = useState([]);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [SearchBy, setSearchBy] = useState("Booking");
  const [totalBookingAmount, setTotalBookingAmount] = useState(null);
  const [agentValue, setAgentValue] = useState();
  const [toDate, setToDate] = useState("");
  const [pnr, setPnr] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  const [show, setShow] = useState(false);
  const [bookingStatus, setBookingStatus] = useState("");

  const modalClose = () => setShow(false);

  const dateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("HH:mm")}</div>
      </div>
    );
  };

  async function sendTicketInEmailHandler(id) {
    const data = await sendTicketInEmail(id);
    if (data.status === "Success") {
      Swal.fire("Send!", data.message, "success");
    }
  }

  async function getJourneyDetails(e, value) {
    setPassengers(value);
    setShowJourney(true);
  }

  async function getTicketDetails(e, value) {
    const response = await bookingDetails(value.id);
    setTicketData(response.data);
    setShowTicketModal(true);
  }

  async function PrintWebTicket(row) {
    // debugger;
    const response =
      row.bookingMode == "offline" ||
      row.bookingMode == "Offline" ||
      row.bookingMode == "OFFLINE"
        ? await offlineTicketHandler(row.bookingId, true)
        : await ticketHandler(row.bookingId, true);

    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      var blob = new Blob([response.data], { type: "application/pdf" });
      var blobURL = URL.createObjectURL(blob);
      window.open(blobURL);
    }
  }
  const refundInvoicePrint = async (row) => {
    // debugger;
    const response = await refundInvoiceHandler(row.bookingId, true);

    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      var blob = new Blob([response.data], { type: "application/pdf" });
      var blobURL = URL.createObjectURL(blob);
      window.open(blobURL);
    }
  };

  function handlePassengerClose() {
    setShowPassenger(false);
  }
  function handleJourneyClose() {
    setShowJourney(false);
  }

  function handleClose() {
    setShowTicketModal(false);
  }
  const priceFormatter = (cell, row) => (
    <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>
  );
  const gatewayFormatter = (cell, row) => {
    return cell == "TRAVELPORT_GAL" ? "TRAVELPORT GAL" : cell;
  };

  const JourneyType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        {row.journeyType == 1 ? (
          <>
            <div style={{ marginBottom: 5 }}>
              {row?.flightCarrier?.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row?.flightCarrier?.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row?.flightCarrier?.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row?.flightCarrier?.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row?.flightCarrier?.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row?.flightCarrier?.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg={row.isDomestic == true ? "info" : "danger"}>
                {row.isDomestic == true ? "Domestic" : "International"} Oneway
              </Badge>
            </h6>
          </>
        ) : row.journeyType == 2 ? (
          <>
            <div style={{ marginBottom: 5, borderRadius: 15 }}>
              {row?.flightCarrier?.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row?.flightCarrier?.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row?.flightCarrier?.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row?.flightCarrier?.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row?.flightCarrier?.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row?.flightCarrier?.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="warning" style={{ color: "black" }}>
                Domestic Return
              </Badge>
            </h6>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 5 }}>
              {row?.flightCarrier?.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row?.flightCarrier?.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row?.flightCarrier?.flightcarrierCode}.gif`}
                      alt=""
                      height="22"
                      width={"22"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row?.flightCarrier?.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row?.flightCarrier?.flightcarrierCode}.gif`}
                    alt=""
                    height="22"
                    width={"22"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row?.flightCarrier?.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="primary">International Return</Badge>
            </h6>
          </>
        )}
      </div>
    );
  };

  const flightFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        {row.journeyType == 1 ? (
          <Tooltip
            placement="top"
            overlay={
              <div style={{ maxWidth: 250 }}>
                {row?.airportDeparture?.cityName} <FaLongArrowAltRight />{" "}
                {row?.airportDestination?.cityName}
              </div>
            }
          >
            <span>
              {row?.airportDeparture?.cityCode} <FaLongArrowAltRight />{" "}
              {row?.airportDestination?.cityCode}
            </span>
          </Tooltip>
        ) : (
          <Tooltip
            placement="top"
            overlay={
              <div style={{ maxWidth: 250 }}>
                {row?.airportDeparture?.cityName} <FaArrowsAltH />{" "}
                {row?.airportDestination?.cityName}
              </div>
            }
          >
            <span>
              {row?.airportDeparture?.cityCode} <FaArrowsAltH />{" "}
              {row?.airportDestination?.cityCode}
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          {/* {row.currentStatus == "COMPLETED" || row.currentStatus == "REFUND" ? (
            ""
          ) : (
            <Dropdown.Item
              // href="#"
              className="text-primary"
              data-bs-toggle="modal"
              data-bs-target="#virtualbank"
              onClick={(e) => getJourneyDetails(e, row)}
            >
              <MdSystemUpdateAlt className="text-primary me-4"></MdSystemUpdateAlt>
              Update PNR
            </Dropdown.Item>
          )} */}
          <Dropdown.Item
            className="text-primary"
            onClick={() => navigate(`/admin/flight/booking-details/${row.id}`)}
          >
            <FaUserCheck className="text-primary me-4" />
            Booking Details
          </Dropdown.Item>
          {/* {row.currentStatus === "PENDING" && (
            <Dropdown.Item
              // href="#"
              className="text-primary"
              data-bs-toggle="modal"
              data-bs-target="#virtualbank"
              onClick={() => {
                Swal.fire({
                  title: `Refund Process`,
                  html: `
                  <div> <p style="font-weight: bold; font-size: 20px;">${
                    row?.airportDeparture?.cityName
                  }
                  <span style="margin: 0 5px;">&rarr;</span>
                  ${row?.airportDestination?.cityName}</p></div>
                  <table class="table">
                  <tr>
                  <td><h5 style="font-size: 12px;">Merchant Details:</h5></td>
                  <td style="font-size: 12px;">
                  <div>${row?.masterMember?.company}</div>
                  <div>${row.masterMember.memberFullName}(${
                    row?.user?.normalizedUserName
                  })</div>
                 </td>
                </tr>
                  <tr>
                    <td><h5 style="font-size: 12px;">Co Relation Id:</h5></td>
                    <td style="font-size: 12px;">${row.coRelationId}</td>
                  </tr>
                 
 
                  <tr>
                    <td><h5 style="font-size: 12px;margin-top:25px">Refund Amount :</h5></td>
                    <td>
                    <input id="amt" value="${
                      row.netTotalFare == null ? "" : row.netTotalFare
                    }" placeholder="Refund Amount" class="swal2-input" type="number" style="width: 200px; font-size: smaller;">
                    </td>
                  </tr>
                </table>
                  
          `,

                  showCancelButton: true,
                  confirmButtonText: "Confirm",
                  showLoaderOnConfirm: true,
                  allowOutsideClick: false,
                  preConfirm: async () => {
                    // debugger;
                    const res = await refundAmount({
                      id: row.id,
                      refundAmount: Number(
                        document.getElementById("amt").value
                      ),
                      corelationId: row?.coRelationId,
                    });
                    // console.log(res);
                    if (res.data.status == "Success") {
                      Swal.fire({
                        title: res.data.message,
                        icon: "success",
                      });
                      loadBookingDetails();

                      setTimeout(() => {
                        loadTotalAmount();
                      }, 100);
                    } else {
                      Swal.fire({
                        title: "Something went to be wrong",
                        icon: "error",
                      });
                    }
                  },
                });
              }}
            >
              <MdTransferWithinAStation className="text-primary me-4" />
              Refund Amount
            </Dropdown.Item>
          )} */}

          {(row.currentStatus === "COMPLETED" ||
            row.currentStatus === "HOLD" ||
            row.currentStatus === "ON_HOLD" ||
            row.currentStatus === "PARTIAL CANCELLED") && (
            <>
              <Dropdown.Item
                className="text-primary"
                onClick={(e) => {
                  PrintWebTicket(row);
                }}
              >
                <MdOutlineAirplaneTicket className="text-primary me-4"></MdOutlineAirplaneTicket>{" "}
                Ticket
              </Dropdown.Item>

              {/* <Dropdown.Item
                className="text-primary"
                onClick={(e) => sendTicketInEmailHandler(row.id)}
              >
                <MdMarkEmailRead
                  className="text-primary me-4"
                  size={15}
                ></MdMarkEmailRead>
                Send Mail
              </Dropdown.Item> */}
            </>
          )}
          {(row.currentStatus == "FULLY CANCELLED" ||
            row.currentStatus == "PARTIAL CANCELLED") && (
            <Dropdown.Item
              className="text-primary"
              onClick={(e) => {
                refundInvoicePrint(row);
              }}
            >
              <FaFileInvoice className="text-primary me-4"></FaFileInvoice>
              Refund Invoice
            </Dropdown.Item>
          )}
        </DropdownButton>
      </>
    );
  };
  const CarrierChargesFormatter = (cell, row) => {
    return (
      <>
        {row.flightCommissionType == "Negative" ? (
          <span className="text-center" style={{ color: "red" }}>
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        ) : row.flightCommissionType == "Positive" ? (
          <span className="text-center" style={{ color: "green" }}>
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        ) : (
          <span className="text-center text-primary">
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        )}
      </>
    );
  };

  const userType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        <Row>
          <Col>
            <div>{row?.masterMember?.company}</div>
            <div>{row?.user?.normalizedUserName}</div>
          </Col>
        </Row>
      </>
    );
  };
  const pnrFormatter = (cell, row) => {
    return (
      <>
        {row.currentStatus == "PENDING" || row.currentStatus == "REFUND" ? (
          ""
        ) : (
          <Tooltip placement="top" overlay={<div>{row.pnr}</div>}>
            <span>
              <Button variant="outline-primary" size="sm">
                Check PNR
              </Button>
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const columns = [
    {
      dataField: "id",
      text: "Action",
      formatter: actionFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "journeyType",
      text: "Airlines",
      formatter: JourneyType,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },

    {
      dataField: "invoiceDate",
      text: "Booking Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From - To",
      formatter: flightFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "departureDate",
      text: "Journey Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },

    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: pnrFormatter,
    },
    {
      dataField: "currentStatus",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },

    {
      dataField: "user.normalizedUserName",
      text: "User",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: userType,
    },

    {
      dataField: "netTotalFare",
      text: "Booked Price",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "apiGateway",
      text: "Gateway",

      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
      formatter: gatewayFormatter,
    },
    {
      dataField: "bookingMode",
      text: "Booking Mode",

      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
    },
    {
      dataField: "totalCarrierServiceCharges",
      text: "Commission",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: CarrierChargesFormatter,
    },
    {
      dataField: "adminMarkupAmount",
      text: "Markup",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "tdsAmount",
      text: "TDS Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    // {
    //   dataField: "adminSGst",
    //   text: "Ticket ",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "150px", textAlign: "center" };
    //   },
    //   formatter: ticketFormatter,
    // },
    {
      dataField: "refundStatus",
      text: "Refund Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
  ];

  function rowStyle(row, rowIndex) {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    if (row.hasFrequentFlyer) {
      style.backgroundColor = "#f5ebff";
    }
    return style;
  }

  function NoDataIndication() {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  }
  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fromDate":
        setFromDate(value);
        break;
      case "toDate":
        setToDate(value);
        break;
      case "pnr":
        setPnr(value);
        break;
      case "SearchBy":
        setSearchBy(value);
        break;
      case "agentValue":
        setAgentValue(value);
        break;
      case "bookingStatus":
        setBookingStatus(value);
        break;

      default:
        break;
    }
  };
  async function loadBookingDetails() {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      fromDate,
      toDate,
      SearchBy,
      pnr,
      agentValue,
      transactionStatus: bookingStatus,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getBookingHistoryByDist(query);

    const getDistinctRecords = (data) => {
      const seenCoRelationIds = new Set();
      const result = [];

      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        // If combo is false and not null, treat as separate, set journeyType to 1
        if (item.combo === false && item.combo !== null) {
          result.push(item);
          continue;
        }
        // Otherwise, merge based on coRelationId
        if (!seenCoRelationIds.has(item.coRelationId)) {
          seenCoRelationIds.add(item.coRelationId);

          const filteredData = data.filter(
            (entry) => entry.coRelationId === item.coRelationId
          );

          const lastOccurrence = filteredData[filteredData.length - 1];

          if (lastOccurrence.journeyType == 2) {
            lastOccurrence.netTotalFare = filteredData.reduce(
              (sum, entry) => sum + entry.netTotalFare,
              0
            );
          }

          if (
            lastOccurrence.journeyType == 2 ||
            lastOccurrence.journeyType == 3
          ) {
            lastOccurrence.totalCarrierServiceCharges = filteredData.reduce(
              (sum, entry) => sum + entry.totalCarrierServiceCharges,
              0
            );
            lastOccurrence.tdsAmount = filteredData.reduce(
              (sum, entry) => sum + entry.tdsAmount,
              0
            );
          }

          // ✅ Check all passengers across entries with the same coRelationId
          const hasFrequentFlyer = filteredData.some(
            (entry) =>
              entry.passengerList &&
              entry.passengerList.some(
                (passenger) =>
                  passenger.frequentFlyerNo &&
                  passenger.frequentFlyerNo.trim() !== ""
              )
          );

          lastOccurrence.hasFrequentFlyer = hasFrequentFlyer;

          result.push(lastOccurrence); // ✅ Push the final object
        }
      }
      // console.log(result);

      return result;
    };

    const distinctRecords = getDistinctRecords(response.data.data);
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setLoading(false);
    setData(distinctRecords);
    setDataCount(paggingData.TotalCount);
  }

  const loadTotalAmount = async () => {
    const totalAmountReq = {
      memId: agentValue,
      fromDate: fromDate,
      toDate: toDate,
      transactionType: "Booking",
      transactionStatus: bookingStatus,
    };
    const totalAmountRes = await totalAmountService(totalAmountReq);
    // console.log(totalAmountRes);
    const totalAmount = totalAmountRes?.data?.totalDebitAmount;
    setTotalBookingAmount(totalAmount);
  };
  useEffect(() => {
    loadBookingDetails();

    setTimeout(() => {
      loadTotalAmount();
    }, 100);
  }, [
    page,
    sizePerPage,
    fromDate,
    toDate,
    pnr,
    SearchBy,
    agentValue,
    bookingStatus,
  ]); // Call loadBookingDetails whenever page or sizePerPage changes

  function handleTableChange(type, { page, sizePerPage }) {
    setPage(page);
    setSizePerPage(sizePerPage);
  }

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    await loadBookingDetails();
    setTimeout(() => {
      loadTotalAmount();
    }, 100);
  };
  const refreshFilter = (e) => {
    setFromDate("");
    setToDate("");
    setPnr("");
    setSearchBy("");
    setAgentValue();
    setSelectedValue(null);
    setBookingStatus("");
    // setTimeout(() => {
    //   loadTotalAmount();
    // }, 100);

    // loadBookingDetails();
  };
  const exportAllReq = async () => {
    const query = queryString.getQueryStringFromObj({
      fromDate,
      SearchBy,
      toDate,
      pnr,
      agentValue,
      TransactionStatus: bookingStatus,
    });
    if (dataCount != 0) {
      setLoading(true);
    }

    const response = await exportBookedFlightByDist(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_Flight_Booked_List.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Booking History</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Booking History" }]}></Breadcrumb>
      <div className="bookingList-header" style={{ marginBottom: 20 }}>
        <Row>
          <Col lg={12} xs={12} sm={12} md={12}>
            {totalBookingAmount != null && (
              <div className="float-end me-4">
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                  }}
                >
                  <span className="text-primary">Total Booking Amount:</span> ₹{" "}
                  {Number(totalBookingAmount).toFixed(2)}
                </span>
              </div>
            )}{" "}
          </Col>
          <Col lg={12} xs={12} sm={12} md={12}>
            <Row>
              <Col xs={12} md={2}>
                <div className="form-group">
                  <label>Search By</label>
                </div>
                <select
                  className="form-select"
                  name="SearchBy"
                  value={SearchBy}
                  onChange={handleSearchChanges}
                >
                  <option value={"Booking"}>Booking</option>
                  <option value={"Travel"}>Travel</option>
                </select>
              </Col>
              <Col xs={12} md={2}>
                <div className="form-group">
                  <label>Date From</label>
                </div>
                <input
                  type="date"
                  className="form-control"
                  name="fromDate"
                  value={fromDate}
                  onChange={handleSearchChanges}
                  max={moment().format("YYYY-MM-DD")}
                />
              </Col>
              <Col xs={12} md={2}>
                <div className="form-group">
                  <label>Date To</label>
                </div>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  value={toDate}
                  onChange={handleSearchChanges}
                  max={moment().format("YYYY-MM-DD")}
                />
              </Col>
              <Col xs={12} md={2}>
                <div className="form-group">
                  <label>PNR</label>
                </div>
                <input
                  type="text"
                  placeholder="PNR"
                  className="form-control"
                  name="pnr"
                  value={pnr}
                  onChange={handleSearchChanges}
                />
              </Col>
              <Col xs={12} md={2}>
                <div className="form-group">
                  <label>Agency</label>
                </div>
                <MemberAutoComplete
                  selectedValue={selectedValue}
                  setSelectedValue={setSelectedValue}
                  name="agentValue"
                  // state={state}
                  setState={setAgentValue}
                />
                {/* <input
                  placeholder="Details"
                  type="text"
                  className="form-control"
                  name="agentValue"
                  value={agentValue}
                  onChange={handleSearchChanges}
                /> */}
              </Col>

              <Col xs={12} md={2}>
                <div className="form-group">
                  <label>Booking Status</label>
                </div>
                <select
                  className="form-select"
                  name="bookingStatus"
                  value={bookingStatus}
                  onChange={handleSearchChanges}
                >
                  <option value={""}>Select option</option>
                  <option value={"Complete"}>Complete</option>
                  <option value={"Pending"}>Pending</option>
                  <option value={"Refund"}>Refund</option>
                  <option value={"Partial Cancelled"}>
                    Partial Cancellation
                  </option>
                  <option value={"Fully Cancelled"}>Fully Cancellation</option>
                  <option value={"Hold"}>Hold</option>
                  <option value={"Unconfirmed"}>Unconfirmed</option>
                </select>
              </Col>
              <Col xs={12} md={12}>
                <div
                  style={{
                    paddingTop: "1%",
                    justifyContent: "flex-end",
                    display: "flex",
                    // alignItems: "center",
                  }}
                >
                  <button
                    className="btn btn-outline-primary"
                    onClick={handleSearch}
                  >
                    <MdSearch size={15} />
                  </button>
                  <button
                    className="btn btn-primary mx-2"
                    onClick={refreshFilter}
                  >
                    <MdOutlineRefresh size={15} />
                  </button>
                  <Button
                    variant="outline-primary"
                    onClick={handleExport}
                    disabled={!dataCount}
                  >
                    {/* Export */}
                    <AiFillFileExcel size={15} />
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              columns
              // canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
      {showTicketModal && (
        <TicketModal
          show={showTicketModal}
          handleClose={handleClose}
          response={ticketData}
        />
      )}
      {showPassenger && (
        <PassengerModal
          show={showPassenger}
          handleClose={handlePassengerClose}
          response={passengers}
        />
      )}
      {showJourney && (
        <PnrAlert
          show={showJourney}
          handleClose={handleJourneyClose}
          response={passengers}
          loadBookingDetails={loadBookingDetails}
        />
      )}
      {show && (
        <Insurance show={show} modalClose={modalClose} response={passengers} />
      )}
    </>
  );
}

export default BookingHistory;
